import { render } from "./vlabelmanageedit.vue?vue&type=template&id=84c70eaa&scoped=true"
import script from "./vlabelmanageedit.vue?vue&type=script&lang=js"
export * from "./vlabelmanageedit.vue?vue&type=script&lang=js"

import "./vlabelmanageedit.vue?vue&type=style&index=0&id=84c70eaa&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c70eaa"]])

export default __exports__